import { useCallback, useState } from "react";
import { TPostFeedbackPayload, TPostFeedbackResponse, postFeedback } from "api";
import axios from "axios";

export const usePostFeedback = () => {
  const [data, setData] = useState<TPostFeedbackResponse | null>(null)
  const [error, setError] = useState<any>(null)
  const [isLoading, setIsLoading] = useState<boolean>(false)

  const postData = useCallback(async (payload: TPostFeedbackPayload) => {
    setData(null)
    setError(null)
    setIsLoading(true)

    try {
      await postFeedback(payload)
      setData({ success: true })
    } catch (error: unknown) {
      if (axios.isAxiosError(error)) {
        if (error.response) {
          setError(error.response)
        } else {
          setError(error)
        }
      } else {
        setError(error)
      }
    } finally {
      setIsLoading(false)
    }
  }, [])

  return {
    postFeedbackData: data,
    postFeedbackErrorData: error,
    isPostFeedbackLoading: isLoading,
    postFeedback: postData
  }
}